import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-bexley',
    templateUrl: './page-bexley.component.html',
    styleUrls: ['./page-bexley.component.css'],
    standalone: false
})
export class PageBexleyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  schools = [
    { name: 'Beths Grammar School', url: 'https://www.beths.bexley.sch.uk/' },
    { name: 'Bexley Grammar School', url: 'https://www.bexleygs.co.uk/'},
    { name: 'Townley Grammar School, ', url: 'https://www.townleygrammar.org.uk/'},
    { name: 'Chislehurst & Sidcup Grammar School', url: 'https://www.csgrammar.com/'},
  ]


}
